import { useEffect, useState } from "react"

import { Obj, load } from "scrivito"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"
import { IMAGE_OVERLAY } from "shared/context/overlay/types"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"
import { useOverlay } from "shared/lib/useOverlay"

import { useInstallationReferenceObjTransformer } from "entities/building-references/model/useInstallationReferenceObjTransformer"
import { InstallationReferenceFilterState } from "entities/building-references/types/InstallationReferenceFilterState"
import { useProductOptions } from "entities/products/model/useProductOptions"

import { InstallationReferenceSelectionModel } from "../InstallationReferenceSelection"

interface UseInstallationReferenceSelectionModelArgs {
  defaultFilters?: InstallationReferenceFilterState
  defaultSelectedInstallationReferenceIDs?: string[]
  onSubmit: (selectedInstallationReferenceIDs: string[] | null) => void
}

export function useInstallationReferenceSelectionModel({
  defaultFilters,
  ...rest
}: UseInstallationReferenceSelectionModelArgs): InstallationReferenceSelectionModel {
  const { options: availableProductFilterOptions } = useProductOptions()

  const [installationReferenceObjs, setInstallationReferenceObjs] = useState<
    InstallationReferenceObj[] | undefined
  >(undefined)

  useEffect(() => {
    load(() =>
      Obj.onSite(getCurrentSiteID())
        .where("_objClass", "equals", "InstallationReference")
        .toArray()
    ).then(objs =>
      setInstallationReferenceObjs(objs as InstallationReferenceObj[])
    )
  }, [])

  const installationReferences = useInstallationReferenceObjTransformer({
    installationReferenceObjs
  })

  const { openOverlay: onZoomImage } = useOverlay(IMAGE_OVERLAY)

  return {
    defaultFilters,
    installationReferences,
    availableProductFilterOptions,
    onZoomImage,
    ...rest
  }
}
